import { useEffect, useState } from "react";
import ManageMultipleDeclarationsStep1 from "./steps/ManageMultipleDeclarationsStep1";
import ManageMultipleDeclarationsStep2 from "./steps/ManageMultipleDeclarationsStep2";
import ManageMultipleDeclarationsStep3 from "./steps/ManageMultipleDeclarationsStep3";

export type ManageMultipleDeclarationsStore = {
    data: Record<string, string>[];
    mappings: Record<string, string> | null;
    selectedMapping: string;    
    selectedMappingMapping: Record<string, string>;
    selectedMappingDateMapping: Record<string, string>;
    mappedData: Record<string, string>[];
    step: number;
    pid: string;
    uuid: string;
    newMappingName: string;
};


type Props = {
    close: () => void;
    uuid: string;
    pid: string;
    refresh: () => void;
};

const ManageMultipeDeclarations = (props: Props) => {
    const [store, setStore] = useState<ManageMultipleDeclarationsStore>({
        data: [],
        mappings: null,
        selectedMapping: "",
        selectedMappingMapping: {},
        selectedMappingDateMapping: {},
        mappedData: [],
        step: 1,
        pid: props.pid,
        uuid: props.uuid,
        newMappingName: "",
    });

    useEffect(() => {
        if (store.step === -1) {
            props.close();
        } else if (store.step === 10) {
            props.refresh();
            props.close();
        }
    }, [store.step, props.close]);

    if (store.step === 1) {
        return (
            <ManageMultipleDeclarationsStep1
                close={props.close}
                uuid={props.uuid}
                pid={props.pid}
                refresh={props.refresh}
                setStore={setStore}
                store={store}
            />
        );
    } else if (store.step === 2) {
        return (
            <ManageMultipleDeclarationsStep2
                setStore={setStore}
                store={store}
            />
        );
    } else if (store.step === 3) {
        return <ManageMultipleDeclarationsStep3 
            store={store}
            setStore={setStore}
        />;
    }

    return <>loading ...</>;
};
export default ManageMultipeDeclarations;
